import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Copy, MessageCircle, Facebook } from "lucide-react";
import { track } from "@/lib/engagement";

export const FOUNDER_DISCLAIMER = "Riconoscimento simbolico e gratuito: l'accesso prioritario e in anteprima alle novità è offerto quando disponibile e non dà diritto a premi, denaro o vantaggi garantiti.";

// Link con anteprima social personalizzata (titolo e immagine con il nome), poi porta a /founder.
const shareUrl = (uid) => `${process.env.REACT_APP_BACKEND_URL}/api/share/founder/${uid}`;
const shareText = (name) => `${name} è Founder di Readoo.it, tra i primi lettori di Readoo: le notizie importanti del giorno e le novità in anteprima. Unisciti anche tu`;

const BTN = "inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-hair bg-surface text-xs font-semibold text-onSurface hover:border-brand hover:text-brand transition-colors disabled:opacity-50";

export function FounderShare({ name, uid }) {
  const [copied, setCopied] = useState(false);
  const msg = `${shareText(name)}: ${shareUrl(uid)}`;
  const open = (channel, url) => { track(`founder_shared_${channel}`); window.open(url, "_blank", "noopener,noreferrer"); };
  const copy = async () => {
    try { await navigator.clipboard.writeText(msg); } catch { return; }
    track("founder_shared_link");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div data-testid="founder-share" className="mt-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-subtle mr-1">Condividi:</span>
        <button type="button" data-testid="founder-share-whatsapp" className={BTN}
          onClick={() => open("whatsapp", `https://wa.me/?text=${encodeURIComponent(msg)}`)}>
          <MessageCircle size={14} /> WhatsApp
        </button>
        <button type="button" data-testid="founder-share-facebook" className={BTN}
          onClick={() => open("facebook", `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl(uid))}`)}>
          <Facebook size={14} /> Facebook
        </button>
        <button type="button" data-testid="founder-share-copy" className={BTN} onClick={copy}>
          {copied ? <><Check size={14} /> Link copiato</> : <><Copy size={14} /> Copia link</>}
        </button>
      </div>
      <p data-testid="founder-disclaimer" className="mt-2 text-[11px] text-subtle">
        {FOUNDER_DISCLAIMER} <Link to="/termini#founder" data-testid="founder-terms-link" className="underline hover:text-brand">Termini</Link>
      </p>
    </div>
  );
}
